import React from 'react';

import { Navigate, useLocation } from 'react-router';

import { appRoutes } from '@clearverify/constants';

export const SignupPageLegacyRedirect: React.FC = () => {
  const location = useLocation();

  const newPath = React.useMemo(() => {
    // 2 is 'consumer-signup' in /auth/consumer-signup/:inviteId:
    const from = appRoutes.auth.signupEmployeeLegacy.split('/')[2] || '';
    const to = appRoutes.auth.signupEmployee.split('/')[2] || '';

    return location.pathname.replace(from, to);
  }, [location.pathname]);

  return <Navigate to={newPath} />;
};
